<template>
  <tag-cloud-widget
    class="box-height-100"
    :title="title"
    :words="words"
    :max-value="maxBy.value"
  />
</template>
<script>
import _ from 'lodash'

import apiRealtime from '@/apis/realtime'
import TagCloudWidget from '@/components/echart/tag_cloud'

export default {
  components: {
    TagCloudWidget
  },
  props: {
    refresh: Boolean,
    from: String,
    to: String
  },
  data() {
    return {
      title: 'Popular words in last 30 mins',
      words: [],
      maxBy: { name: '', value: 0 },
      maxValue: 0,
      color: ['#555555', '#555555', '#555555', '#555555']
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getTagCloud()
      }
    }
  },
  methods: {
    async getTagCloud() {
      try {
        const data = await apiRealtime.getTagCloud()

        this.words = []
        if (data.data.length > 0) {
          this.maxBy = _.maxBy(data.data, 'value')
        }
        this.maxValue = this.maxBy.value

        for (const item of data.data) {
          this.words.push({
            text: item.name,
            weight: item.value,
            color: this.getColor(item.value),
            rotation: this.getRotation()
          })
        }

        this.$emit('reset', 'tagCloud')
      } catch (error) {}
    },
    getColor(weight) {
      return weight > this.maxValue * 0.75
        ? this.color[0]
        : weight > this.maxValue * 0.5
        ? this.color[1]
        : weight > this.maxValue * 0.25
        ? this.color[2]
        : this.color[3]
    },
    getRotation() {
      const deg = [45, 315]
      return _.head(_.shuffle(deg))
    }
  }
}
</script>
